<svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path
    clip-rule="evenodd"
    d="M4.496 18.009h-.102a.507.507 0 0 1-.355-.153.558.558 0 0 1-.152-.481l1.065-4.893c.026-.09.08-.17.152-.228l8.265-8.29A3.119 3.119 0 0 1 15.651 3a3.194 3.194 0 0 1 2.281.938c.603.617.94 1.445.938 2.307a3.194 3.194 0 0 1-.938 2.282l-8.29 8.29a.481.481 0 0 1-.253.127l-4.893 1.065Zm13.36-11.79a2.206 2.206 0 0 0-3.752-1.571l3.119 3.144a2.13 2.13 0 0 0 .633-1.547V6.22Zm-1.343 2.283-3.119-3.119-7.225 7.225 3.118 3.093 7.226-7.2Zm-8.24 7.63-2.51-2.51-.71 3.22 3.22-.71Zm-4.766 4.615h16.986a.507.507 0 0 1 0 1.014H3.507a.507.507 0 0 1 0-1.014Z"
    fill="currentColor"
    fill-rule="evenodd"
  />
</svg>
